import { useEffect } from "react";
import { SITE_URL } from "@/lib/site";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/* Per-route title, description, canonical and robots. Index pages pass a
   path; private pages (panel, guest form, admin) pass noindex. */
export const useSeo = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    if (typeof document === "undefined") return;
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (path !== undefined) {
      const url = SITE_URL + path;
      setLink("canonical", url);
      setMeta("property", "og:url", url);
    } else {
      document.head.querySelector('link[rel="canonical"]')?.remove();
    }
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, path, noindex]);
};

export const SEO = {
  tr: {
    title: "RateGuard · Otel misafir geri bildirim sistemi | QR ile şikâyet yönetimi",
    description:
      "Oteller için QR kodlu misafir geri bildirim sistemi. Düşük puan anında resepsiyona sesli uyarıyla düşer, memnun misafir Google'da yorum bırakır. Uygulama yok, aynı gün kurulum.",
    path: "/",
  },
  en: {
    title: "RateGuard · Hotel guest feedback system | QR complaint management",
    description:
      "QR-based guest feedback for hotels. Low ratings reach the front desk instantly with a sound alert; happy guests are invited to review you on Google. No app, same-day setup.",
    path: "/en",
  },
  sr: {
    title: "RateGuard · Sistem za povratne informacije gostiju hotela | QR",
    description:
      "QR sistem za povratne informacije gostiju u hotelima. Niska ocena odmah stiže na recepciju uz zvučno upozorenje, a zadovoljni gosti ostavljaju recenziju na Google-u.",
    path: "/sr",
  },
};
